// import {useState, useEffect, useRef} from "react";
// import SectionTitle from "../SectionTitles/SectionTitle";
import SectionTitleTwo from "../SectionTitles/SectionTitleTwo";
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import {Link} from "react-router-dom";

const HomeAbout = () => {
  // const [scale] = useState(1.04);
  // const sceneEl = useRef(null);

  // useEffect(() => {
  //     const parallaxInstance = new Parallax(sceneEl.current, {
  //     relativeInput: true,
  //     })

  //     parallaxInstance.enable();

  //     return () => parallaxInstance.disable();

  // }, [])
  return (
    <div className="section section-padding-t90 section-padding-t50-b0">
      <div className="container">
        {/* <SectionTitle title="Introduction" /> */}

        <div className="row">
          {/* <div className="col-xl-7 col-lg-6 col-12" data-aos="fade-up">
                        <div className="about-image-area">
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/home-one-about/home_agency_about_1.jpg"} alt="" />
                                </Tilt>
                            </div>
                        
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/home-one-about/home_agency_about_2.jpg"} alt="" />
                                </Tilt>
                            </div>
                            <div className="shape shape-1" id="scene" ref={sceneEl}>
                                <span data-depth="1"><img src={process.env.PUBLIC_URL + "images/shape-animation/about-shape-1.png"} alt="" /></span>
                            </div>

                        </div>
                    </div> */}

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              <SectionTitleTwo
                // subTitle="Every day brings new challenges"
                title="Overview of Data Mining and Big Data (DMBD)"
              />
              <div className="intro">
                <p className="home-p text-justify">
                  The Eighth International Conference on Data Mining and Big Data (DMBD&apos; 2023) serves as an international forum for researchers and practitioners to exchange latest advantages in theories, algorithms, models,
                  and applications of data mining and big data as well as artificial intelligence techniques. Data mining refers to the activity of going through big data sets to look for relevant or pertinent information Big data contains huge amount of data and information and is worth researching in depth.
                </p>
                <p className="home-p text-justify">
                  DMBD&apos;2023 is the
                  eighth event after the preceding Guangzhou, Belgrade, Chiang Mai, Shanghai, Fukuoka, Bali and Beijing events
                  where more than hundreds of delegates from all over the world to attend and share their
                  latest achievements, innovative ideas, marvelous designs and excel implementations.
                </p>

                <p className="home-p text-justify">
                  This year&apos;s main theme is <strong>FinTech</strong>, and we will pay special attention to technologies
                  and applications in
                  the
                  area of FinTech.
                </p>
                <p className="home-p text-justify">
                  DMBD&apos;2023 will be held during December 9th-12th, 2023 in Sanya, China.
                  Sanya,located in the southernmost of Hainan Island, known as Lucheng, also known as &quot;Eastern Hawaii&quot;,
                  is the southernmost tropical coastal tourism city in China.
                  It ranks first among China&apos;s four first-tier tourist cities &quot;Sanwei Hangxia&quot; and boasts the most beautiful seaside scenery on the island.
                </p>


                {/* <p>
                  The Thirteenth International Conference on Swarm Intelligence
                  (ICSI&apos;2022) serves as the most important forum for researchers
                  and practitioners to exchange latest advantages in theories,
                  technologies, and applications of swarm intelligence and
                  related areas.
                </p>
                <br></br>
                <p>
                  Swarm intelligence (SI) is an important concept in artificial
                  intelligence and computer science with emergent properties. SI
                  is one of the most effective methods to confront the modern
                  complex problems in real world. A lot of novel algorithms are
                  springing up. ICSI provides the best communication
                  opportunities for SI researchers and practitioners annually.
                </p>
                <br></br>
                <p>
                  The ICSI&apos;2022 will be held in Xi&apos;an, China.
                  Xi&apos;an is the capital of Shaanxi Province. A
                  sub-provincial city on the Guanzhong Plain in Northwest China,
                  it is one of the oldest cities in China, the oldest prefecture
                  capital and one of the Chinese Four Great Ancient Capitals,
                  having held the position under several of the most important
                  dynasties in Chinese history, including Western Zhou, Qin,
                  Western Han, Sui, Northern Zhou and Tang. The city is the
                  starting point of the Silk Road and home to the UNESCO World
                  Heritage set Terracotta Army of Emperor Qin Shi Huang.
                </p> */}
              </div>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              {/* <SectionTitleTwo 
                                // subTitle="Every day brings new challenges"
                                title="International Conference on Swarm Intelligence"
                            /> */}

              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <p className="home-p text-justify">
                Sanya is an amazing place with beautiful beaches, rainforests, coral reefs and beautiful mountains, as well as rich culture and cuisine.
                Yalong Bay, known as the &quot;first Bay under heaven&quot;, has a silver beach, fine sand, clean and transparent sea water.
                You can see the coral clearly, showing several different blue colors from the distance.
              </p>
              <p className="home-p text-justify">
                Papers presented at DMBD&apos;2023 will be published Springer-Nature in Communications in Computer and
                Information Science (CCIS) (indexed by EI, ISTP, DBLP, SCOPUS, ISI, Web of Science, etc.) The downloads
                of our meeting&apos;s proceedings reach the top 25% of all publications of Springer-Nature. Some high-quality
                papers will be selected for SCI-indexed Transaction (including IEEE Trans, Swarm and Evolutionary
                Optimization, etc.) and Journal Special Issues, such as:
                <ul className="home-p">
                  <li>
                    International Journal of Intelligence System (IF=8.71)
                  </li>
                  <li>
                    Electronics (IF=2.690)
                  </li>
                  <li>
                    Multimedia Tools and applications (IF=2.58)
                  </li>
                  <li>
                    Machine Learning with Applications (IF=8.67)
                  </li>
                  <li>
                    IASEI Transactions on Swarm Intelligence
                  </li>
                  <li>
                    ...
                  </li>
                </ul>
              </p>
              {/* <p>
                The ICSI&apos;2022 is the thirteenth annual event in this
                high-reputation ICSI series following the continuous twelfth
                previous events at Qingdao ,Belgrade (Online Webinar), Chiang
                Mai, Shanghai, Fukuoka, Bali, Beijing, Hefei, Harbin, Shenzhen,
                Chongqing and Beijing.
              </p>
              <br></br>
              <p>
                Papers presented at the ICSI&apos;2022 will be published by
                Springer-Nature in Lecture Notes in Computer Science (indexed by
                EI Compendex, ISTP, DBLP, SCOPUS, Web of Science ISI Thomson,
                etc.). The downloads of our meeting&apos;s proceedings reach the
                top 25% of all publications of Springer-Nature.
              </p>
              <br></br>
              <p>
                Some high-quality papers will be selected for SCI-indexed
                Transaction (including IEEE Trans, Swarm and Evolutionary
                Optimization, etc.) and Journal Special Issues:
                <li>
                  International Journal of Intelligent System (IJIS, IF=10.78)
                </li>
                <li>Electronics (IF=2.412)</li>
                <li>Entropy (IF=2.524)</li>
                <li>IASEI Transactions on Swarm Intelligence</li>
                <li>……</li>
              </p> */}

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
